<template>
  <v-dialog v-bind="$attrs" v-on="$listeners" :value="value" @input="onInput">
    <template v-slot:default="{ attrs, on }">
      <slot v-bind="{ attrs, on }"></slot>
    </template>
    <template v-slot:activator="{ attrs, on }">
      <slot name="activator" v-bind="{ attrs, on }"></slot>
    </template>
  </v-dialog>
</template>

<script>
export default {
  name: 'dialog-scroll-lock',

  props: [ 'value' ],

  created() {
    this.$set(this.global.scrollLock, this._uid, Boolean(this.value));
  },

  destroyed() {
    this.$delete(this.global.scrollLock, this._uid);
  },

  methods: {
    onInput(v) {
      this.$set(this.global.scrollLock, this._uid, v);
      this.$emit('input', v);
    }
  }
}
</script>
